







import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { frontendClient } from "../lib/client"

declare let Plotly:any;

@Component({
    components:{

    }
})
export default class Graph extends Vue{

    @Prop({}) title:string;
    @Prop({}) Xaxis:string;
    @Prop({}) Yaxis:string;
    @Prop({}) hideBar:boolean;

    @Prop({}) data:{
        time:number,
        values?:{
            y_letters?:number,
            y_workedHours?:number,
        }
    }[];
    @Prop({}) yVal:string;

    xData:number[] = [];
    yData:number[] = [];

    graphData = null;
    layout= {
        title: this.title,
        xaxis: {
            title: this.Xaxis || null,
            type: "date",
            fixedrange: true
        },
        yaxis: {
            rangemode:"tozero",
            fixedrange: true
        },
        margin: {
        t: 35, //top margin
        l: 35, //left margin
        r: 35, //right margin
        b: 50, //bottom margin
        pad: 10,
        },
    };

    mounted(){
        if(this.data){
            this.extractValues();
            this.establishGraph();
        }
    }

    extractValues(){
        this.yData = [];
        this.xData = [];

        for(let i=0;i<this.data.length;i++){
            this.xData.push(this.data[i].time);
            if(this.yVal){
                this.yData.push(this.data[i].values[this.yVal]);
            }else{
                frontendClient.giveError("Your graphs must have a scope - yVal");
            }
        }

        this.graphData = [
            {
                x: this.xData,
                y: this.yData,
                mode: 'lines+markers',
                line: {
                    color: '#3674ff',
                    width: 3,
                    shape: "spline",
                },
                fill: 'tozeroy',
                fillcolor: '#3674ff80',
            }
        ];
    }

    establishGraph(){
        let container = this.$refs.container;
        Plotly.newPlot(container,this.graphData, this.layout,{displayModeBar: !this.hideBar,scrollZoom: false})
    }

    @Watch('data')
    updateGraph(){
        this.extractValues();
        this.establishGraph();
    }

}
